import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IWorkOrderDependencyMaps } from "@miplatform/types";

export const useWorkOrderDependencyMaps = () => {
  const stateManager = useComponentState();

  const [dependencyMaps, setDependencyMaps] = useState<
    IWorkOrderDependencyMaps[]
  >([]);

  const getOrderTemplateWorkOrderTemplates = async (id: string) => {
    stateManager.run(async () => {
      const res =
        await taskService.workOrderDependencyMaps.getOrderTemplateWorkOrderTemplates(
          { id }
        );

      if (res.status === HTTP_STATUSES.OK) {
        setDependencyMaps(res.data);
      }
    });
  };

  const upsertOrderTemplateWorkOrderTemplates = async ({
    data,
    id,
  }: {
    id: string;
    data: {
      maps: Partial<IWorkOrderDependencyMaps>[];
    };
  }) => {
    stateManager.run(async () => {
      const res =
        await taskService.workOrderDependencyMaps.putOrderTemplateWorkOrderTemplates(
          {
            data,
            id,
            toastMessageConfig: {
              success: {
                text: "Successfully updated work order dependencies.",
              },
              error: { text: "Failed to update work order dependencies." },
            },
          }
        );

      if (res.status === HTTP_STATUSES.OK) {
        setDependencyMaps(res.data);
      }
    });
  };

  return {
    dependencyMaps,
    setDependencyMaps,
    isLoading: stateManager.isBusy(),
    getOrderTemplateWorkOrderTemplates,
    upsertOrderTemplateWorkOrderTemplates,
  };
};
